import {
  Box,
  Stack,
  Typography
} from '@mui/material';
import React from 'react';

export type InsufficientAccessBackgroundProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InsufficientAccessBackgroundProps) => {

  return (
    <Stack
      sx={{
        background: 'linear-gradient(0deg, rgba(2, 0, 67, 0.00) 72.6%, rgba(2, 0, 67, 0.02) 99.87%), var(--Supporting-white, #FFF)'
      }}
      // overflow={props.overflow && props.overflow}
      justifyContent='stretch'
      alignItems='stretch'
      borderRadius='1.5rem'
      border='6px solid white'
      direction='column'
      paddingX='2rem'
      paddingY='2rem'
      rowGap='1.5rem'
    >
      <Box
        height='calc(100vh - 15rem)'
        display='flex'
        justifyContent='center'
      >
        <Typography
          margin='auto'
          variant='h1'
        >
          Insufficient Access
        </Typography>
      </Box>
    </Stack>
  );
};
